import womanPlank1x from './WomanPlank.webp';
import womanPlank2x from './WomanPlank@2x.webp';
import womanPlank3x from './WomanPlank@3x.webp';
import womanPlank1xAvif from './WomanPlank.avif';
import womanPlank2xAvif from './WomanPlank@2x.avif';
import womanPlank3xAvif from './WomanPlank@3x.avif';

/**
 * Same asset as the patient app `getAsset('WomanPlank')`, with @2x/@3x for responsive density.
 *
 * AVIF with a WebP baseline. The original PNG export is gone: it was a photograph in a lossless
 * container, 1540 KB at 3x against 40 KB of AVIF, and it was what made the banner load in late.
 *
 * Both formats are needed, but the split is lopsided. Measured over 30 days of production
 * onboarding sessions (18.591 of them), 0,36 % run a browser without AVIF: iOS 15 Safari and a
 * handful of iOS 16.0 to 16.3. Every one of those reads WebP, so the two together cover the whole
 * audience, and the fallback costs three small files rather than 2,5 MB of PNG.
 */
export const womanPlankHeroImage = {
  src: womanPlank1x,
  srcSet: `${womanPlank1x} 1x, ${womanPlank2x} 2x, ${womanPlank3x} 3x`,
  avifSrcSet: `${womanPlank1xAvif} 1x, ${womanPlank2xAvif} 2x, ${womanPlank3xAvif} 3x`,
} as const;

/**
 * Warms the hero from an earlier screen. It first appears one screen after insurance-select on
 * every billing path, so the fetch costs idle time the patient is already spending on that choice.
 * Requests the AVIF set, which is what 99,6 % of sessions will render.
 */
export function prefetchOnboardingHero(): void {
  const hero = new Image();
  hero.srcset = womanPlankHeroImage.avifSrcSet;
  hero.src = womanPlankHeroImage.src;
}
